import reportWebVitals from "./reportWebVitals";
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ConfigProvider } from "antd";
import mnMN from "antd/locale/mn_MN";
import dayjs from "dayjs";
import "dayjs/locale/mn";
import App from "./App";
import "./index.css";
import "./App.css";
import "antd/dist/reset.css";

dayjs.locale("mn");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <ConfigProvider locale={mnMN}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ConfigProvider>
  </React.StrictMode>
);

reportWebVitals();